{
  "nl": {
    "activity": {
      "attributes": {
        "end": "Begin",
        "now": "Nu",
        "title": "Activiteiten"
      },
      "labels": {
        "no_activities": "Nog geen activiteiten",
        "no_activities_subtitle": "Wanneer iemand een nieuwe aankondiging, beslissing, vraag, enzovoort plaatst, zie je die hier.",
        "not_opened_yet": "Nog niet gezien"
      },
      "projects": {
        "announcement": {
          "create": "heeft een nieuwsbericht geplaatst."
        },
        "building": {
          "create": "heeft gebouw <i>{notifiable_name}</i> aangemaakt."
        },
        "document": {
          "create": "heeft document <i>'{notifiable_name}'</i> geüpload."
        },
        "lot": {
          "create": "heeft lot <i>{notifiable_name}</i> aangemaakt."
        },
        "phase": {
          "create": "heeft fase <i>{notifiable_name}</i> aangemaakt."
        },
        "published": {
          "customer": "heeft beslissing <i>'{notifiable_name}'</i> zichtbaar gemaakt voor de klant.",
          "partners": "heeft beslissing <i>'{notifiable_name}'</i> zichbaar gemaakt voor de leverancier(s)."
        },
        "question": {
          "create": "heeft de vraag <i>'{notifiable_name}'</i> toegevoegd in FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "create": "heeft ruimte <i>{notifiable_name}</i> aangemaakt.",
          "update": "heeft ruimte <i>{notifiable_name}</i> toegewezen aan een unit."
        },
        "survey_type": {
          "create": "heeft enquête <i>'{notifiable_name}'</i> aangemaakt."
        },
        "ticket": {
          "create": "heeft gesprek <i>{notifiable_name}</i> gestart."
        },
        "unit": {
          "assign": "heeft unit <i>{notifiable_name}</i> toegewezen.",
          "create": "heeft unit <i>{notifiable_name}</i> aangemaakt.",
          "invisibled": "heeft klantoegang ontnomen voor unit <i>'{notifiable_name}'</i>.",
          "unassign": "heeft klant verwijderd van unit <i>'{notifiable_name}'</i>.",
          "visibled": "heeft klanttoegang gegeven voor unit <i>'{notifiable_name}'</i>."
        }
      },
      "units": {
        "announcement": {
          "create": "heeft een nieuwsbericht geplaatst."
        },
        "decision": {
          "create": "heeft beslissing <i>'{notifiable_name}'</i> aangemaakt.",
          "not_interested": "is niet geïnteresseerd in beslissing <i>'{notifiable_name}'</i>.",
          "published": {
            "customer": "heeft beslissing <i>'{notifiable_name}'</i> zichtbaar gemaakt voor de klant.",
            "partners": "heeft beslissing <i>'{notifiable_name}'</i> zichbaar gemaakt voor de leverancier(s)."
          },
          "relaunched": "heeft de beslissing <i>'{notifiable_name}'</i> weer beschikbaar gemaakt."
        },
        "decision_document": {
          "create": "heeft document <i>'{notifiable_name}'</i> geüpload in beslissing <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "heeft voorstel <i>'{notifiable_name}'</i> aanvaard in beslissing <i>'{group_name}'</i>.",
          "create": {
            "customer": "heeft voorstel <i>'{notifiable_name}'</i> gedeeld met de klant.",
            "employee": "heeft voorstel <i>'{notifiable_name}'</i> aangemaakt.",
            "partnergroup": "heeft voorstel <i>'{notifiable_name}'</i> gedeeld met leverancier(s) <i>{target_name}</i>."
          },
          "unapproved": "heeft de goedkeuring in voorstel <i>'{notifiable_name}'</i> in beslissing <i>'{group_name}' ongedaan gemaakt</i>.",
          "updated": "heeft voorstel <i>'{notifiable_name}'</i> in beslissing <i>'{group_name}' verwijderd</i>."
        },
        "document": {
          "create": "heeft document <i>'{notifiable_name}'</i> geüpload.",
          "destroy": "heeft document <i>'{notifiable_name}'</i> verwijderd."
        },
        "issue": {
          "approval": {
            "create": "heeft de goedkeuring van de klant gevraagd.",
            "delete": "heeft het goedkeuringsverzoek geannuleerd.",
            "rejected": "heeft dit punt verworpen."
          },
          "approved": "heeft het punt goedgekeurd.",
          "create": "heeft het punt aangemaakt.",
          "status": {
            "update": "heeft de status van issue <i>'{notifiable_name}'</i> gewijzigd in <i>{target_name}</i>."
          }
        },
        "proposal": {
          "deleted": "heeft voorstel <i>'{notifiable_name}'</i> verwijderd."
        },
        "question": {
          "create": "heeft de vraag <i>'{notifiable_name}'</i> toegevoegd in FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "update": "heeft ruimte <i>{notifiable_name}</i> toegewezen aan een unit."
        },
        "survey": {
          "create": "heeft enquête <i>'{notifiable_name}'</i> aangemaakt.",
          "published": "heeft enquête <i>'{notifiable_name}'</i> zichtbaar gemaakt voor de klant."
        },
        "ticket": {
          "create": "heeft gesprek <i>{notifiable_name}</i> gestart.",
          "message": {
            "move": "heeft een bericht verplaatst naar gesprek <i>'{notifiable_name}'</i>."
          }
        },
        "unit": {
          "assign": "heeft unit <i>{notifiable_name}</i> toegewezen.",
          "invisibled": "heeft klanttoegang ontnomen voor unit <i>'{notifiable_name}'</i>.",
          "unassign": "heeft klant verwijderd van unit <i>'{notifiable_name}'</i>.",
          "visibled": "heeft klanttoegang gegeven voor unit <i>'{notifiable_name}'</i>."
        }
      }
    }
  }
}
